/**
 * Component for showing a dropdonw with a country selection
 *
 */
import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import { FormGroup } from '@angular/forms';


@Component({
    selector: 'selectfield',
    templateUrl: './input.select.component.html'
})
export class SelectComponent implements OnInit {
    /**
     * Label for the field
     */
    @Input() label: string;

    /**
     * Error message ivalid input
     */
    @Input() error: string;

    /**
     * Name of the element
     */
    @Input() name: string;

    /**
     * Value for the element
     */
    @Input() value: string;

    /**
     * mandatory field or not
     */
    @Input() required: boolean;

    /**
     * Model for saving the value
     */
    @Input() model: any;

    /**
     * Class for the html-wrapper element
     */
    @Input() wrapperClass: string;

    /**
     * List of options for the field
     */
    @Input() options: any;

    /**
     * current form element
     */
    @Input() form: FormGroup;

    /**
     * Eventemitter if the value is changed
     * @type {EventEmitter<any>}
     */
    @Output() modelChange: EventEmitter<any> = new EventEmitter();

    /**
     * called if the component is initialized
     */
    public ngOnInit(): void {

    }

    /**
     * Returns if the field is valid or not
     * @returns {boolean}
     */
    elementValid(): boolean {
        return this.form.controls[this.name].disabled ||
            this.form.controls[this.name].touched == false ||
            this.form.controls[this.name].valid == true;
    }

    /**
     * Function to update the model and inform the parent Component about it.
     * We can not use databinding here because it will not work together with
     * @param event
     */
    updateModel(event:any) {
        this.model = event.target.value;
        this.modelChange.emit(this.model);
    }
}
